import axios from "axios"

function request(method, path, data, params) {
  const token = localStorage.getItem("token")
  return axios({ method, url: "/api/contract-workspace/public" + path, data, params, headers: token ? { Authorization: token } : {} }).then(response => response.data)
}

async function download(path, filename) {
  const response = await axios.get("/api/contract-workspace/public" + path, { headers: { Authorization: localStorage.getItem("token") }, responseType: "blob" })
  const url = URL.createObjectURL(response.data), link = document.createElement("a")
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export default {
  studios: () => request("get", "/studios"),
  catalog: studioId => request("get", "/catalog", null, { studioId }),
  me: () => request("get", "/me"),
  summary: () => request("get", "/summary"),
  updateProfile: data => request("put", "/me", data),
  prepare: data => request("post", "/prepare", data),
  quote: data => request("post", "/quotes", data),
  create: data => request("post", "/agreements", data),
  agreements: (offset = 0) => request("get", "/agreements", null, { offset }),
  agreement: id => request("get", "/agreements/" + encodeURIComponent(id)),
  contractPdf: id => download("/agreements/" + encodeURIComponent(id) + "/pdf", "Vertrag.pdf"),
  invoicePdf: (id, invoiceId) => download("/agreements/" + encodeURIComponent(id) + "/invoices/" + encodeURIComponent(invoiceId) + "/pdf", "Rechnung.pdf"),
}
